import { ConnectProto } from "@racoon/api";

/**
 * Whether a stored day counts toward the month total: worked and planned days do;
 * a planned day off and a no-show (MISSED) do not. The backend's month_total also
 * counts no-shows, so the total is counted here instead.
 */
export const countsInTotal = (cell?: ConnectProto.ShiftScheduleCell) =>
  !!cell &&
  cell.state !== ConnectProto.ShiftCellState.UNDEFINED &&
  cell.state !== ConnectProto.ShiftCellState.MISSED &&
  cell.planType !== ConnectProto.ShiftPlanType.DAY_OFF;

export const monthTotal = (row: ConnectProto.DriverShiftScheduleRow) =>
  row.cells.filter(countsInTotal).length;
